<template>
    <div class="create-leave">
        <v-dialog :value="value.state"  max-width="600px" persistent scrollable>
             <v-card>
                <v-card-title>
                    {{ value.item === undefined ? "Tạo mới " : "Cập nhật "}} phiếu hỗ trợ xác nhận giờ công
                    <v-spacer></v-spacer>
                    <v-btn small text @click="close"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-subtitle>
                    <b class="mr-1 error--text">Lưu ý: </b>
                    Bạn phải gởi và duyệt các phiếu phép (nếu có) trước khi yêu cầu duyệt công.
                </v-card-subtitle>
                <v-card-text>
                <v-form @submit.prevent="saveData" v-model="valid" id="form" ref="form">
                    <v-row>
                        <v-col cols="12">
                            <v-menu
                            v-model="menuDate1"
                            :close-on-content-click="false"
                            max-width="290"
                            >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                :value="formatValidFrom"
                                clearable
                                label="Ngày chấm công"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="form.workDate = null"
                                :rules="[v=> !!v ||'Nhập dữ liệu này!']"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                locale="vi"
                                v-model="form.workDate"
                                @change="menuDate1 = false"
                            ></v-date-picker>
                            </v-menu>
                            <!-- <v-text-field label="Bắt đầu" type="date" v-model="form.validFrom" :rules="[v=> !!v ||'Nhập dữ liệu này!']"></v-text-field> -->
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="Giờ cần xác nhận" v-model="form.worktime" :rules="[v=> !!v ||'Nhập dữ liệu này!']" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select label="Lý do" :items="reasons" v-model="form.reasonTypeCode" item-text="name" item-value="code" :rules="[v=> !!v ||'Nhập dữ liệu này!']" outlined persistent-placeholder></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea label="Diễn giải (bắt buộc)" v-model="form.note" :rules="[v=> !!v ||'Nhập dữ liệu này!']" outlined persistent-placeholder></v-textarea>
                        </v-col>
                        <v-col cols="12">
                            <file-upload v-model="form.imageUrl" label="Hình ảnh (bắt buộc)"
                            accept=".jpg,.jpeg,.png" @uploading="fileUploading = true" @uploaded="fileUploading=false" hint="Hình ảnh chứng minh, xác thực sự cố"></file-upload>
                        </v-col>
                    </v-row>
                </v-form>       
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark form="form" color="primary" type="submit" v-show="!fileUploading">
                        Lưu
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
             </v-card>
        </v-dialog>
    </div>
</template>

<script>
import DatePicker from "../../../components/DatePicker";
import http from '../../../components/services/http-common';
import EventBus  from "../../../components/services/EventBus";
import moment from 'moment'
import FileUpload from "../../../components/FileUpload.vue";
import {post} from "./api"
import helper from '@/components/services/Helper';

export default {
    name: "Create",
    components: {
        "date-picker": DatePicker,
        "file-upload": FileUpload
    },
    computed:{
        formatValidFrom () {
            return this.form.workDate ? moment(this.form.workDate).format('DD/MM/YYYY') : ''
        },
        // formatValidTo () {
        //     return this.form.validFrom ? moment(this.form.validFrom).format('DD/MM/YYYY') : ''
        // },
        amount() {
            let amount = 0;
            const day = (1000*60*60*24);
            if(Array.isArray(this.dates))
            {
                if(this.form.isMultiple)
                {
                    if(this.dates.length == 2){
                        let first = new Date(this.dates[0]);
                        let last = new Date(this.dates[1]);
                        amount = (last -first)/day;
                        return Math.abs(amount) +1;
                    }
                }
            }
            return amount;
        }
    },
    watch: {
        value: {
            handler(val){
                if(val.item != undefined)
                    this.fetchData();
                if(val.state)
                    return val || this.close();
            }
        },
        "form.isMultiple": {
            handler(val)
            {
                if(val)
                    this.dates = [];
                else
                    this.dates = "";
            }
        },
    },

    props: ["value"],
    data () {
        return {
            //URL
            ROOT_URL: "employeeRotationRequests",
            LEAVEPLAN_URL: "leavePlans/valid-leave-plan/",
            LEAVEPLAN_URL2: "leavePlans/valid-leave-plan2/",

            //DATA
            valid: false,
            dateMenu: false,
            employees:[],
            departments:[],
            reasons: [],
            dates: "",
            ShiftObject: "",
            form: {
                workDate: moment().format("YYYY-MM-DD"),
                note: "",
                worktime: 0,
                imageUrl: null,
                longitude: 0,
                latitude: 0,
                reasonTypeCode: null
            },
            
            menuDate1: false,
            menuDate2: false,
            defaultForm: {
                workDate: moment().format("YYYY-MM-DD"),
                note: "",
                worktime: 0,
                imageUrl: null,
                longitude: 0,
                latitude: 0,
                reasonTypeCode: null
            },
            fileUploading: false,

            //EMPLOYEE DIALOG
            employeeDialog: false,
            selectedField: "",

            geoLocation: {
                longitude: 0,
                latitude: 0,
            }
        }
    },
    methods: {
        messageToast (eventObj) {
            EventBus.$emit('hasMessage', eventObj);
        },
        errorToast (eventObj)
        {
            EventBus.$emit('hasError', eventObj);
        },

        formatTime(value) {
            return moment(value).format("HH:mm:ss");
        },
        dateApply (){
            if(this.isMultiple)
            {
                let dates = this.dates;
                let dt0 = new Date(dates[0]);
                let dt1 = new Date(dates[1]);
                if(dt0> dt1)
                    this.dates = [dates[1], dates[0]];
            }
            this.$refs.menu.save(this.dates);
        },

        close () {
            this.$emit("CloseDialog");
            this.$refs.form.resetValidation();
            this.form = Object.assign({}, this.defaultForm);
        },
        
        fetchData () {
            return http.get(this.ROOT_URL + "/" + this.value.item.code)
            .then(res => {
                //fetch result
                let item = res.data.item;
                this.form = Object.assign({}, item);
                console.log(this.form);
            })
            .catch(err => {
                console.log(err);
            });
        },

        fetchEmployee() {
            return http.get("employees/fetch?asm=false&detail=true").then(res => {
                this.employees = res.data.map(x => {
                    return {
                        text: `${x.name}`,
                        value: x.code
                    }
                })
            })
        },

        fetchDepartment() {
            return http.get("departments").then(r => {
                this.departments = r.data.map(x => {
                    return {
                        text: x.name,
                        value: x.code
                    }
                })
            })
        },

        fetchReason() {
            return http.get("TimesheetConfirmRequests/reasons").then(r => r.data).then(data => {
                this.reasons = data.data
                }
            )
        },
        
        saveData() {
            this.$refs.form.validate();
            if(this.valid)
            {
                if(!this.value.item)
                {
                    this.form.longitude = this.geoLocation.longitude
                    this.form.latitude = this.geoLocation.latitude
                    return post(this.form)
                    .then(res => {
                        this.$emit("fetchData");
                    })
                    .catch(err => {
                        // this.errorToast({message: err.response.data.message, toast: true})
                    });
                } else {
                    alert("not implemented")
                    // return http.put(this.ROOT_URL + "/" + this.value.item.code, this.form)
                    // .then(res => {
                    //     let eventObj = {
                    //         color: "success",
                    //         message: "Cập nhật thành công",
                    //         toast: true,
                    //     };
                    //     this.messageToast(eventObj);
                    //     this.$emit("fetchData");
                    // })
                    // .catch(err => {
                    //     throw "Đã có lỗi xảy ra"
                    // });
                }
                this.close();
            }
        },
    },
    mounted() {
        helper.getGeo().then(d => {
            this.geoLocation = {...d}
        })

        this.fetchEmployee()
        this.fetchDepartment()
        this.fetchReason()
    }
}
</script>